import LeftNav from "../LeftNav";
import React, { useState, useEffect, useRef } from "react";
import '../styles/Images2.css';
import View1 from "./image/View1";
import View2 from "./image/View2";
import PageModal from "../modals/PageModal";
import { authorizedHttpGet } from "../../api/httpCalls";
import urls from '../../api/urls.json'
import Loader from "../Loader";
import EmptyView from "../EmptyView";
import { useLocation, useNavigate } from "react-router-dom";


const Images = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const authToken = localStorage.getItem('authToken');
    const isOtpVerified = localStorage.getItem('verificationPassed');
    if (!authToken || !isOtpVerified) {
        sessionStorage.setItem('redirectUrl', location.pathname)
        navigate('/login')
    }

    const [appName, setAppName] = useState(localStorage.getItem('appName'))
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [togglePageModal, setTogglePageModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [profiles, setProfiles] = useState([]);
    const [loadError, setLoadError] = useState(null);
    const totalProfiles = useRef(0);
    const latestRequest = useRef(0);


    const fetchViewTwoFourData = async (url) => {
        const requestId = ++latestRequest.current;
        setIsLoading(true);
        setLoadError(null);
        try {
            const response = await authorizedHttpGet(url, { page });
            if (requestId !== latestRequest.current) return;
            const data = response?.data;
            if (!response?.status || !Array.isArray(data?.profiles)) {
                throw new Error('Invalid Images response');
            }
            setProfiles(data.profiles);
            setTotalPages(data.total_pages ?? 0);
            totalProfiles.current = data.total_profiles ?? 0;
        } catch (error) {
            if (requestId !== latestRequest.current) return;
            setProfiles([]);
            setTotalPages(0);
            totalProfiles.current = 0;
            setLoadError('Unable to load images. Please try again.');
        } finally {
            if (requestId === latestRequest.current) setIsLoading(false);
        }
    };

    useEffect(() => {
        setProfiles([])
        fetchViewTwoFourData(urls.GET_IMAGES_UPDATE_DISAPPROVED);
        return () => { latestRequest.current += 1; };
    }, [page, appName]);


    const handleLeftNavAppChange = (name) => {
        setAppName(name)
        setPage(1)
    };

    const goToPage = (pageModalNumber) => {
        setTogglePageModal(false);
        if (pageModalNumber > totalPages) {
            alert("Page number is greater than total pages");
        } else {
            setPage(pageModalNumber);
        }
    }

    const afterSave = async () => {
        setProfiles([])
        fetchViewTwoFourData(urls.GET_IMAGES_UPDATE_DISAPPROVED);
    }


    const cancelReview = () => {
        // setPage(page + 1)
    }

    const screenWidth = window.innerWidth;
    const isIpad = screenWidth === 1180;

    return (
        <div className="App imagesMainDiv">
            {togglePageModal && <PageModal closeModal={() => setTogglePageModal(false)} page={page} goToPage={goToPage} />}
            {isLoading && <Loader isLoading={isLoading} />}
            <LeftNav handleLeftNavAppChange={handleLeftNavAppChange} tabName={'Images'} />
            <div className={!isIpad ? "mainDiv" : "mainDivIpad"}>
                <div className="headerText">
                    <div className="pageNumber" onClick={() => setTogglePageModal(true)}>
                        <span className="selectedSpan">{page}</span>
                        <span className="unSelectedSpan">{totalPages}</span>
                        <span className="unSelectedSpan">{totalProfiles.current}</span>
                    </div>
                </div>

                {
                    !isLoading && !loadError && profiles.length > 0 && <View2 profiles={profiles} cancelReview={cancelReview} isView2={false} page={page} afterSave={afterSave} likeLabel="Accept" passLabel="Reject" />
                }
                {
                    !isLoading && !loadError && profiles.length === 0 && <EmptyView />
                }
                {loadError && <div role="alert">
                    <p>{loadError}</p>
                    <button type="button" onClick={() => fetchViewTwoFourData(urls.GET_IMAGES_UPDATE_DISAPPROVED)}>Retry</button>
                </div>}
            </div>
        </div>
    );
};

export default Images;
